<script lang="ts">
import WordBoard from "./components/WordBoard.svelte";
import confetti from "canvas-confetti";
import { initializeApp } from 'firebase/app';
import Auth from './components/Auth.svelte';
import Header from "./components/Header.svelte";
import UserForm from "./components/UserForm.svelte";
import MenuSidebar from "./components/MenuSidebar.svelte";
// import ProfileSidebar from "./components/ProfileSidebar.svelte";
import CreateChallenge from "./components/CreateChallenge.svelte";
import Dashboard from "./components/Dashboard.svelte";
import BoggleBoard from "./components/BoggleBoard.svelte";

const firebaseConfig = {
  apiKey: "AIzaSyCodq72nj7ietCKEAs43YUMo17YeEgh0m4",
  authDomain: "wordle-challenge-app.firebaseapp.com",
  projectId: "wordle-challenge-app",
  storageBucket: "wordle-challenge-app.appspot.com",
  messagingSenderId: "282333156471",
  appId: "1:282333156471:web:298ad46d2164f1f6ad2272"
};

initializeApp(firebaseConfig);

var myCanvas = document.createElement('canvas');
myCanvas.style.position = 'absolute'
myCanvas.style.top = '0'
myCanvas.style.bottom = '0'
myCanvas.style.right = '0'
myCanvas.style.left = '0'
myCanvas.style.width = '100vw'
myCanvas.style.height = '100vh'
myCanvas.style.zIndex = '-1'
document.body.appendChild(myCanvas);

var myConfetti = confetti.create(myCanvas, { resize: true, particleCount: 150 });
const throwConfetti = () => {
  myCanvas.style.zIndex = '1000'
  myConfetti();

  setTimeout(() => {
    myCanvas.style.zIndex = '-1'
    myConfetti.reset();
  }, 4000);
}

// window.fbAsyncInit = function() {
//     FB.init({
//       appId      : '490551756026899',
//       cookie     : true,
//       xfbml      : true,
//       version    : 'v13.0'
//     });
      
//     FB.AppEvents.logPageView();   
      
//   };

//   (function(d, s, id){
//      var js, fjs = d.getElementsByTagName(s)[0];
//      if (d.getElementById(id)) {return;}
//      js = d.createElement(s); js.id = id;
//      js.src = "https://connect.facebook.net/en_US/sdk.js";
//      fjs.parentNode.insertBefore(js, fjs);
//    }(document, 'script', 'facebook-jssdk'));
let busy = true
let menu_show = false;
let profile_show = false;
let page = 'boggle'
const selectPage = (p: string) => {
  page = p
}
</script>

<main class="p-0">
  <Auth
    useRedirect={true}
    bind:busy
    let:user
    let:loggedIn
    let:loginWithGoogle
    let:loginWithFacebook
    let:loginWithEmailPassword
    let:loginAnonymously
    let:registerWithEmailPassword
    let:logout
  >
    {#if busy}
      <div class="w-full h-96 flex items-center justify-center">
        <div class="animate-spin text-teal-700">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-refresh" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
            <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
          </svg>
        </div>
      </div>
    {:else if loggedIn}
      <Header user={user} showTimer={page === 'wordle'} showCountdown={page === 'boggle'} toggleMenu={() => menu_show = !menu_show} toggleProfile={() => profile_show = !profile_show} />
      {#if page === 'dashboard'}
        <Dashboard />
      {:else if page === 'wordle'}
        <WordBoard on:success={throwConfetti} />
      {:else if page === 'boggle'}
        <BoggleBoard on:success={throwConfetti} />
      {:else if page === 'createChallenge'}
        <CreateChallenge />
      {/if}
      
    {:else}
      <UserForm loginWithGoogle={loginWithGoogle} loginWithFacebook={loginWithFacebook} loginAnonymously={loginAnonymously} loginWithEmailPassword={loginWithEmailPassword} registerWithEmailPassword={registerWithEmailPassword} />
    {/if}
    <MenuSidebar bind:show={menu_show} page={page} pageSelect={selectPage} logout={logout} />
    <!-- <ProfileSidebar bind:show={profile_show} logout={logout} /> -->
  </Auth>
</main>

<style windi:preflights:global windi:safelist:global>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}
</style>